import { CYBER_CONSTANT } from 'constants';

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  Typography,
  Grid,
  Card,
  Button,
} from '@genie-ui/react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PropTypes from 'prop-types';

import { getDisplayValue, isEmptyValue, getStateFromPercentile } from 'utils';
import StateBadge from 'components/atoms/statebadge';
import KpiIcon from 'components/atoms/kpiicon';

function KpiCard({
  sideDrawer,
  item,
  currentView,
  index,
  benchmarkForKpiData,
}) {
  const { showPrint } = useSelector((state) => state.cyber);
  const localPercentile = (currentView
    ? benchmarkForKpiData?.[item?.kpiId]?.currentBenchmark?.percentile
    : benchmarkForKpiData?.[item?.kpiId]?.targetBenchmark?.percentile);
  const state = useMemo(() => getStateFromPercentile(localPercentile), [localPercentile]);

  return (
    <Card
      className="paper"
      variant="outlined"
      key={item.header}
    >
      <Grid item>
        {showPrint && (
          <div className="kpiIconWrapper kpiIconWrapper--print" id={`kpiIcon-${item?.kpiId}`}>
            <KpiIcon kpiId={item?.kpiId} />
          </div>
        )}

        {isEmptyValue(
          currentView
            ? item?.curValue
            : item?.tarValue,
        ) ? (
          <StateBadge state={state} />
          ) : (
            <div className="lockedText">
              <LockOutlinedIcon
                sx={{
                  fontSize: 16,
                }}
              />
            </div>
          )}
        <Typography className="cardTitle">{item.header}</Typography>
      </Grid>
      <div>
        <Grid className="drawerTitleContainer">
          {(currentView && isEmptyValue(item?.curValue)) && (
            <>
              <Typography className="kpiValueHeading">
                {`${CYBER_CONSTANT.LABEL.CURRENT} ${item?.curEstimateCheck ? ` ${CYBER_CONSTANT.LABEL.EST}` : ''}`}
                <b>
                  {`${parseFloat(Number(item?.curValue)?.toFixed(1))} ${
                    item?.unit || ''
                  }`}
                </b>
              </Typography>
              <Typography className="kpiValueHeading">
                {CYBER_CONSTANT.LABEL.MEDIAN}
                <b>
                  {getDisplayValue(
                    benchmarkForKpiData?.[item?.kpiId]?.currentBenchmark
                      ?.medianPeer,
                    item?.curValue,
                    item?.unit,
                  )}
                </b>
              </Typography>
              <Typography className="kpiValueHeading">
                {CYBER_CONSTANT.LABEL.NSIZE}
                <b>
                  {(benchmarkForKpiData?.[item?.kpiId]?.currentBenchmark?.nsize)
                    || CYBER_CONSTANT.LABEL.THRESHOLD_VAL}
                </b>
              </Typography>
            </>
          )}
          {(!currentView && isEmptyValue(item?.tarValue)) && (
            <>
              <Typography className="kpiValueHeading">
                {CYBER_CONSTANT.LABEL.TARGET}
                <b>
                  {`${parseFloat(Number(item?.tarValue)?.toFixed(1))} ${
                    item?.unit || ''
                  }`}
                </b>
              </Typography>
              <Typography className="kpiValueHeading">
                {CYBER_CONSTANT.LABEL.MEDIAN}
                <b>
                  {getDisplayValue(
                    benchmarkForKpiData?.[item?.kpiId]?.targetBenchmark
                      ?.medianPeer,
                    item?.tarValue,
                    item?.unit,
                  )}
                </b>
              </Typography>
              <Typography className="kpiValueHeading">
                {CYBER_CONSTANT.LABEL.NSIZE}
                <b>
                  {(benchmarkForKpiData?.[item?.kpiId]?.targetBenchmark?.nsize)
                    || CYBER_CONSTANT.LABEL.THRESHOLD_VAL}
                </b>
              </Typography>
            </>
          )}
        </Grid>
        {isEmptyValue(
          currentView
            ? item?.curValue
            : item?.tarValue,
        ) ? (
          <Button
            className="getBenchmark"
            variant="ghost"
            onClick={sideDrawer(true, index)}
          >
            {CYBER_CONSTANT.LABEL.VIEW_INSIGHTS}
          </Button>
          ) : (
            <Button
              className="getBenchmark"
              variant="ghost"
              onClick={sideDrawer(true, index)}
            >
              {CYBER_CONSTANT.LABEL.GET_BENCHMARK}
            </Button>
          )}
      </div>
    </Card>
  );
}

export default KpiCard;

KpiCard.propTypes = {
  sideDrawer: PropTypes.func.isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  currentView: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  benchmarkForKpiData: PropTypes.instanceOf(Object).isRequired,
};
